<script>
  import { onMount, onDestroy } from "svelte";
  import { getNextInputId } from "../../helper/UIHelper";
  import Image from "../display/Image.svelte";
  import Button from "./Button.svelte";
  import { createEventDispatcher } from "svelte";

  export let model;
  // export let label;
  export let placeholderImage;
  export let previewMode = 0;
  export let minMode = false;
  export let linkText;
  export let disabled;
  let preview;
  let val;
  let className = "";
  let styles = "";
  let dropZone;
  let isFileDragOver = false;

  export { className as class };

  export { styles as style };
  export let uid = getNextInputId();

  //TODO Add support for multiple files files[0];

  const dispatch = createEventDispatcher();
  const change = () => dispatch("change");

  onMount(() => {
    addDragAndDropHandler();
    if (model != null) {
      setPreview(model);
    }
    dispatch("onInit");
  });

  const onInputChange = function() {
    let files = document.getElementById(uid).files;
    //1 MB = 1048576
    if (files[0].size > 10485760) {
      alert("File is too big!");
      val = null;

      return;
    }
    model = files[0];
    setPreview(model);
    change();
  };

  const onClick = function() {
    if(minMode && disabled)
      return;
    document.getElementById(uid).click();
  };

  const clearModel = function() {
    model = null;
    preview = null;
    isFileDragOver = false;
    change();

    /*Need to rebind event handlers, because html will get lost after model is set*/
    setTimeout(() => {
      addDragAndDropHandler();
    }, 100);
  };

  function setPreview(file) {
    if (file != null) {
      var reader = new FileReader();

      reader.onload = function(e) {
        preview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  function handleFileDrop(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    isFileDragOver = false;

    var files = evt.dataTransfer.files; // FileList object.
    model = files[0];
    change();

    setPreview(model);
  }

  function handleDragLeave(evt) {
    isFileDragOver = false;
  }

  function handleDragOver(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    isFileDragOver = true;

    evt.dataTransfer.dropEffect = "copy"; // Explicitly show this is a copy.
  }

  function addDragAndDropHandler() {
    if (dropZone != null) {
      dropZone.removeEventListener("dragover", handleDragOver, false);
      dropZone.removeEventListener("drop", handleFileDrop, false);
      dropZone.removeEventListener("dragleave", handleDragLeave, false);
    }
    dropZone = document.getElementById(`${uid}_container`);
    if (dropZone == null) return;
    dropZone.addEventListener("dragover", handleDragOver, false);
    dropZone.addEventListener("drop", handleFileDrop, false);
    dropZone.addEventListener("dragleave", handleDragLeave, false);
  }

</script>

<div class={className} style={styles}>
  {#if minMode == false}
    <div
      id="{uid}_container"
      class="mt-2 flex justify-center border-dashed rounded-md"
      class:border-gray-700={isFileDragOver}
      class:border-2={model == null || isFileDragOver}
      class:px-6={model == null || isFileDragOver}
      class:pt-5={model == null || isFileDragOver}
      class:pb-6={model == null || isFileDragOver}
      class:border-gray-300={!isFileDragOver}>
      {#if model == null}
        <div class="text-center">
          {#if placeholderImage != null}
            <div
              class="mx-auto {placeholderImage.class} bg-no-repeat bg-center
              bg-contain"
              style="background-image:url('{placeholderImage.url}')" />
          {:else}
            <svg
              class="mx-auto h-12 w-12"
              class:text-gray-700={isFileDragOver}
              class:text-gray-400={!isFileDragOver}
              stroke="currentColor"
              fill="none"
              viewBox="0 0 48 48">
              <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0
                01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8
                32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12
                4h.02"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          {/if}
          {#if !isFileDragOver}
            <p class="mt-1 text-sm text-main">
              <button
                type="button"
                on:click={onClick}
                class="font-medium text-smfblack-100 hover:text-smfblack-200
                focus:outline-none underline transition duration-150 ease-in-out">
                Upload a file
              </button>
              or drag and drop
            </p>
            <p class="mt-1 text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
          {:else}
            <p class="mt-1 text-xl text-main" style="padding:6.5px 0">
              Drop here
            </p>
          {/if}
        </div>
      {:else}
        <div class="block">
          <Image
            src={preview}
            class="h-auto w-full"
            mode={previewMode}
            isExternal={true}
            id="preview_{uid}" />
          <div class="text-sm text-center text-gray-500 pt-4">
            <a href="/" on:click|preventDefault|stopPropagation={onClick}>
              <span class="underline">Change</span>
            </a>
            <span>or</span>
            <a href="/" on:click|preventDefault|stopPropagation={clearModel}>
              <span class="underline">Delete</span>
            </a>
          </div>
        </div>
      {/if}
    </div>
  {:else}
    <div>
      {#if model == null}
         <p class="mt-1 text-sm text-main">
              <button
                type="button"
                on:click={onClick}
                class="font-medium text-smfblack-100 hover:text-smfblack-200
                focus:outline-none underline transition duration-150 ease-in-out">
                {linkText}
              </button>
              </p>
      {:else}
        <div class="block" on:click={onClick}>
          <Image
            src={preview}
            class="h-auto w-full"
            mode={previewMode}
            isExternal={true}
            id="preview_{uid}" />
        </div>
      {/if}
    </div>
  {/if}

</div>

<input
  class="hidden w-0 h-0"
  type="file"
  accept="image/*"
  name={uid}
  bind:value={val}
  on:change={onInputChange}
  id={uid} />
